import React from "react";
import PropTypes from "prop-types";
import { Container } from "@raketa-cms/raketa-cms";

const SectionTitleWidget = ({ title, description, containerSettings }) => (
  <Container className="section-title-wrapper" settings={containerSettings}>
    <div className="container">
      <div className="container-inner">
        <h3 className="section-title">{title}</h3>
        {description && <h5 className="section-sub-title">{description}</h5>}
      </div>
    </div>
  </Container>
);

SectionTitleWidget.title = "Section Title";
SectionTitleWidget.category = "General";

SectionTitleWidget.defaultProps = {
  description: "",
};

SectionTitleWidget.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  containerSettings: PropTypes.object.isRequired,
};

SectionTitleWidget.defaults = {
  title: "Headline",
  description: "",
  containerSettings: {},
};

SectionTitleWidget.adminFields = {
  title: { type: "text" },
  description: { type: "text" },
};

export default SectionTitleWidget;
